import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appNgSelectLabelDirective]',
  standalone: true,
})
export class NgSelectLabelDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
